var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/medal-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8337 24.6275L26.6337 25.1475C26.1403 25.2675 25.7537 25.6408 25.647 26.1341L25.1803 28.0941C24.927 29.1608 23.567 29.4941 22.8603 28.6541L18.8737 24.0675C18.5537 23.6941 18.727 23.1075 19.207 22.9875C21.567 22.4141 23.687 21.0941 25.247 19.2141C25.5003 18.9075 25.9537 18.8675 26.2337 19.1475L29.1937 22.1075C30.207 23.1208 29.847 24.3875 28.8337 24.6275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.09631 24.6275L6.29631 25.1475C6.78964 25.2675 7.17631 25.6408 7.28298 26.1341L7.74964 28.0941C8.00298 29.1608 9.36298 29.4941 10.0696 28.6541L14.0563 24.0675C14.3763 23.6941 14.203 23.1075 13.723 22.9875C11.363 22.4141 9.24298 21.0941 7.68298 19.2141C7.42964 18.9075 6.97631 18.8675 6.69631 19.1475L3.73631 22.1075C2.72298 23.1208 3.08298 24.3875 4.09631 24.6275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4974 2.66602C11.3374 2.66602 7.16406 6.83935 7.16406 11.9993C7.16406 13.9327 7.7374 15.706 8.72406 17.186C10.1641 19.3193 12.4441 20.826 15.0974 21.2127C15.5507 21.2927 16.0174 21.3327 16.4974 21.3327C16.9774 21.3327 17.4441 21.2927 17.8974 21.2127C20.5507 20.826 22.8307 19.3193 24.2707 17.186C25.2574 15.706 25.8307 13.9327 25.8307 11.9993C25.8307 6.83935 21.6574 2.66602 16.4974 2.66602ZM20.5774 11.706L19.4707 12.8127C19.2841 12.9993 19.1774 13.3593 19.2441 13.626L19.5641 14.9993C19.8174 16.0793 19.2441 16.506 18.2841 15.9327L16.9507 15.146C16.7107 14.9993 16.3107 14.9993 16.0707 15.146L14.7374 15.9327C13.7774 16.4927 13.2041 16.0793 13.4574 14.9993L13.7774 13.626C13.8307 13.3727 13.7374 12.9993 13.5507 12.8127L12.4174 11.706C11.7641 11.0527 11.9774 10.3993 12.8841 10.2527L14.3107 10.0127C14.5507 9.97268 14.8307 9.75935 14.9374 9.54602L15.7241 7.97268C16.1507 7.11935 16.8441 7.11935 17.2707 7.97268L18.0574 9.54602C18.1641 9.75935 18.4441 9.97268 18.6974 10.0127L20.1241 10.2527C21.0174 10.3993 21.2307 11.0527 20.5774 11.706Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.526ce3b375a5e0d5bd3a4fe82b73f32b.svg";
export { ForwardRef as ReactComponent };